import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Button } from '../../components/ui/button';
import { LogOut } from 'lucide-react';
import { InterviewManagement } from '../../components/admin/InterviewManagement';
import { APISettingsTab } from '../../components/admin/APISettingsTab';
import { ExportsTab } from '../../components/admin/ExportsTab';

export const AdminDashboard = () => {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user || user.userType !== 'admin') {
      navigate('/admin');
    }
  }, [user, loading, navigate]);


  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p>Loading...</p>
      </div>
    );
  }

  // Don't render dashboard until we confirm user is admin
  if (!user || user.userType !== 'admin') {
    return null;
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex justify-between items-center">
          <h1 className="text-2xl font-light tracking-tight" style={{fontFamily: 'Outfit, sans-serif'}}>
            Admin Dashboard
          </h1>
          <Button 
            variant="outline" 
            onClick={logout}
            data-testid="admin-logout-button"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Logout
          </Button>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-6 md:px-12 py-8">
        <Tabs defaultValue="interviews" className="w-full">
          <TabsList className="mb-8" data-testid="admin-tabs">
            <TabsTrigger value="interviews" data-testid="admin-tab-interviews">
              Interview Management
            </TabsTrigger>
            <TabsTrigger value="settings" data-testid="admin-tab-settings">
              API Settings
            </TabsTrigger>
            <TabsTrigger value="exports" data-testid="admin-tab-exports">
              Exports
            </TabsTrigger>
          </TabsList>

          <TabsContent value="interviews">
            <InterviewManagement />
          </TabsContent>

          <TabsContent value="settings">
            <APISettingsTab />
          </TabsContent>

          <TabsContent value="exports">
            <ExportsTab />
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
};
